module.exports = __webpack_public_path__ + "static/Partnered-f72fb84516c712228b387ec92b9a7bb1.png";